import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "./guards/auth.guard";
import { errorRoute } from './layouts';
import { AuthSuccessGuard } from "./guards/auth-success.guard";
const LAYOUT_ROUTES = [
    ...errorRoute
];
const routes: Routes = [
  {
      path: 'login',
      loadChildren: './modules/login/login.module#LoginModule',
      canActivate:[AuthSuccessGuard]
  },
  {
    path: 'dashboard',
    data: {
        authorities: ['ROLE_USER']
    },
    canActivate: [AuthGuard],
    loadChildren: './modules/dashboard/dashboard.module#DashboardModule'
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  ...LAYOUT_ROUTES
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true ,onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
